<script lang="ts" setup>
import { SwitchComponent } from '@metapic-apps/shared'
import type { UploadFile } from 'element-plus'
import { onMounted } from 'vue'
import { useStore } from 'vuex'

import UploadInput from '@/components/UploadInput.vue'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

defineProps<{ id: string; isEditing?: boolean; image?: { base64: string; url: string } }>()
const title = defineModel<string>('title')
const description = defineModel<string>('description')
const logoTemp = defineModel<UploadFile>('logoTemp')
const hasProductSeeding = defineModel<boolean>('hasProductSeeding')

const store = useStore()
onMounted(async () => {
  if (store.getters['onboarding/currentOnboardingStep'] === 2) {
    await store.dispatch('onboarding/setCurrentCard', 'campaign-description-section')
    await store.dispatch('onboarding/setOnboardingActivity', true)
  }
})
</script>
<template>
  <BoxComponent :id="id" :mb="32" :mb-lg="48" :p="24" class="campaign-form__block">
    <BoxComponent id="campaign-description-section" :mb="32">
      <TypographyComponent variant="headline-medium" color="#000000">General</TypographyComponent>
    </BoxComponent>
    <BoxComponent :mb="32">
      <el-form-item prop="title">
        <TypographyComponent variant="title-large">Title</TypographyComponent>
        <el-input v-model="title" size="large" />
      </el-form-item>
    </BoxComponent>
    <BoxComponent :mb="32">
      <el-form-item prop="description">
        <TypographyComponent variant="title-large">Description</TypographyComponent>
        <el-input v-model="description" size="large" />
      </el-form-item>
    </BoxComponent>
    <BoxComponent :mb="32">
      <!-- @vue-expect-error todo fix me-->
      <UploadInput v-model:image-thumbnail="logoTemp" :image="image" prop="logo" placeholder="" :auto-upload="false">
        <template #label>
          <TypographyComponent variant="title-large">
            Your image
            <TypographyComponent variant="body-small">(optional, but recommended for higher engagement)</TypographyComponent>
          </TypographyComponent>
        </template>
        <template #placeholder>
          <BoxComponent :mb="8">
            <FlexComponent direction="column" align="center">
              <TypographyComponent variant="body-small"> Must be JPG or PNG, maximum file size 10MB. </TypographyComponent>
              <TypographyComponent variant="body-small">Best 800x450 pixels. </TypographyComponent>
            </FlexComponent>
          </BoxComponent>
        </template>
      </UploadInput>
    </BoxComponent>
    <SwitchComponent v-model="hasProductSeeding" title="Provide creators with products">
      <template #tooltip>
        <BoxComponent :w="280">
          <BoxComponent :mb="4">
            <TypographyComponent variant="title-medium" color="#031E51">Product seeding</TypographyComponent>
          </BoxComponent>
          <TypographyComponent variant="body-medium">
            Gift products to creators so they share genuine experiences with their audience.
          </TypographyComponent>
        </BoxComponent>
      </template>
    </SwitchComponent>
  </BoxComponent>
</template>
<style lang="scss" scoped>
.text-color {
  color: var(--primary-color);
}

.todo-disclaimer {
  padding: 16px;
  border-radius: 16px;
  background-color: #f3f7f9;
}
</style>
